export default __webpack_public_path__ + "static/media/camera-intelbras.cf495043.png";